import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute -bottom-1.5 -right-1.5" }
const _hoisted_2 = ["title"]

import { Rank } from '@/typings/user';
import Crown from '@/components/Icon/Crown.vue';
import Bolt from '@/components/Icon/Bolt.vue';
import Cog from '@/components/Icon/Cog.vue';
import { computed } from 'vue';

interface Props {
  rank: Rank;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    rank: null
  },
  setup(__props: any) {

const props = __props as {
  rank: Rank;
}



const title = computed(() => {
  switch (props.rank) {
    case Rank.owner:
      return 'Owner';
    case Rank.moderator:
      return 'Moderator';
    case Rank.admin:
      return 'Admin';
    default:
      return 'Member';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex items-center justify-center w-5 h-5 text-white rounded-full text-2xs bg-primary",
      title: _unref(title)
    }, [
      (__props.rank === _unref(Rank).owner)
        ? (_openBlock(), _createBlock(Crown, { key: 0 }))
        : _createCommentVNode("", true),
      (__props.rank === _unref(Rank).moderator)
        ? (_openBlock(), _createBlock(Bolt, { key: 1 }))
        : _createCommentVNode("", true),
      (__props.rank === _unref(Rank).admin)
        ? (_openBlock(), _createBlock(Cog, { key: 2 }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ]))
}
}

})